import script from "./MainSVGEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSVGEditor.vue?vue&type=script&setup=true&lang=js"

import "./MainSVGEditor.vue?vue&type=style&index=0&id=676a358e&lang=scss"

const __exports__ = script;

export default __exports__